module.exports = __webpack_public_path__ + "img/star-map-step_3.f1cc17e.webp";